import { render, staticRenderFns } from "./Validation.vue?vue&type=template&id=5317a4b7&scoped=true&"
import script from "./Validation.vue?vue&type=script&lang=js&"
export * from "./Validation.vue?vue&type=script&lang=js&"
import style0 from "./validation.scss?vue&type=style&index=0&id=5317a4b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5317a4b7",
  null
  
)

export default component.exports